import { IDanhSachLopTinChiSelectRequest } from "../../model/request/lop-tin-chi/IDanhSachLopTinChiSelectRequest";
import { IDanhSachLopTinChiExportRequest } from "../../state/action-types/lop-tin-chi/IDanhSachLopTinChiActions";
import { apiClient } from "../apiClient";
export const DANH_SACH_LOP_TIN_CHI_ENDPOINT = "danh-sach-lop-tin-chi";
export const danhSachLopTinChiApi = {
  SelectChuaTongHop: (request: IDanhSachLopTinChiSelectRequest) =>
    apiClient.post(
      `${DANH_SACH_LOP_TIN_CHI_ENDPOINT}/ra-soat-tong-hop-tin-chi`,
      request
    ),
  ExportExcel: (request: IDanhSachLopTinChiExportRequest) =>
    apiClient.post(`${DANH_SACH_LOP_TIN_CHI_ENDPOINT}/export-excel`, request),
};
